<template>
  <div class="button-underline">
    <RouterLink tag="button" :to="to" @click.native="click" v-html="label" />
    <div></div>
  </div>
</template>

<script>
export default {
  name: "MenubarTab",
  props: {
    to: {
      type: String,
      required: true
    },
    scrollTo: String,
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    click() {
      if (this.scrollTo) this.$scrollTo(this.scrollTo);
    }
  }
};
</script>

<style lang="scss" scoped>
.button-underline {
  display: inline-block;
  text-align: center;
}
button {
  border: none;
  margin: 0;
  padding: 0;
  width: $menubar-tab-width;
  max-width: $menubar-tab-max-width;
  line-height: $menubar-height/2;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: inherit;
  outline: none;
  line-height: normal;
  cursor: pointer;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  + div {
    position: absolute;
    width: 0;
    max-width: $menubar-tab-max-width;
    height: 1px;
    margin-top: -1px;
    background-color: $color-primary-1;
    transition-property: width;
    transition-duration: $button-transition-duration;
    transition-timing-function: $button-transition-timing-function;
  }
  &.router-link-exact-active + div {
    width: $menubar-tab-width;
    max-width: $menubar-tab-max-width;
  }
  &.router-link-exact-active {
    font-weight: 400;
  }
  @media only screen and (min-width: $mobile-width) {
    &:hover + div {
      width: $menubar-tab-width;
      max-width: $menubar-tab-max-width;
    }
  }
}
</style>
